'use client';

import { useEffect, useRef } from 'react';
interface LLPopoverProps {
  text: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
  customClass?: string;
}

const LLPopover: React.FC<LLPopoverProps> = ({
  text,
  position = 'top',
  children,
  customClass = '',
}) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let popoverInstance: any;
    if (popoverRef.current) {
      const modalElement = popoverRef.current?.closest('.modal');
      popoverInstance = new window.bootstrap.Popover(popoverRef.current!, {
        trigger: 'hover',
        placement: position,
        content: text,
        html: true,
        container: modalElement || 'body',
      });
    }
    return () => {
      if (popoverInstance) {
        popoverInstance.dispose();
      }
    };
  }, [text, position]);

  return (
    <div
      ref={popoverRef}
      className={`d-inline-block ${customClass}`}
      data-bs-toggle="popover"
    >
      {children}
    </div>
  );
};

export default LLPopover;
